import useGetUserAddresses from './useGetUserAddresses'
export default useGetUserAddresses
